module.exports = "author = by = creator = writer = created by = written by\n\nby <-> author of\n\nwritten by <-> wrote\n\nemployee <-> employer\n\nemployer = works for\nformer employer <-> former employee\n\nfriend <-> friend\n\nacquired = acquisition\n\ninterested in <-> interests of\n\nadvised by = advisor\n\nartist <-> artist of\n\nrelated to <-> related to\n\nstarring <-> actor of\n\nfounded by = founder\nfounded by <-> founder of\n\ndirected by <-> director of\n\nmusic by <-> composer of\n\nalumnus = alma mater of\nclass of = students\n\nstudied at <-> students\n\ndepends on <-> dependency"


//////////////////
// WEBPACK FOOTER
// ./src/quark/predicates/rules.txt
// module id = 321
// module chunks = 0